"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOTTOM_FRAME_IMAGE = void 0;
const BOTTOM_FRAME_IMAGE = exports.BOTTOM_FRAME_IMAGE = 'bottom-frame-image';
